import { DOMSerializer, Node, Schema } from '@tiptap/pm/model';

const getNodeHtml = (node: Node, schema: Schema): string => {
  const serializer = DOMSerializer.fromSchema(schema);
  const domNode = serializer.serializeNode(node);
  const tempDiv = document.createElement('div');
  tempDiv.appendChild(domNode);
  return tempDiv.innerHTML;
};

export default getNodeHtml;
